import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from '../Services/cookie';

@Component({
  selector: 'app-pay-card-review',
  templateUrl: './pay-card-review.component.html',
  standalone:false,
  styleUrls: ['./pay-card-review.component.scss']
})
export class PayCardReviewComponent implements OnInit {
  Screen: string;

  constructor(private router:Router,private cookieService: CookieService,) { }

 async ngOnInit(): Promise<any> {
    let S = await this.cookieService.get("Screen",false);
    if(S){
      this.Screen = S;
    }
  }

  dashboard() {
    this.router.navigateByUrl("/DashboardCreditCards");
  }

}
